import "./styles.scss";

import classnames from "classnames";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

import adminMenu from "./components/admin";
import clientMenu from "./components/client";
import FloatCard from "./components/FloatCard";
import webmasterMenu from "./components/webmaster";

import { useApp } from "context/app";
import { useNotifications } from "context/notifications";

import { ReactComponent as Logo } from "assets/icons/new/logo-text.svg";
import { ReactComponent as ArrowIcon } from "assets/icons/new/forward-arrow.svg";

const mainClass = "dashboard-layout-sidebar";

const Menu = ({ setSidebarOpen }) => {
  const { t } = useTranslation();
  const { user, current_website } = useApp();
  const { data } = useNotifications();

  const menu_type_render = (user_type, unreaded_count) => {
    switch (user_type) {
      case "client":
        return clientMenu(unreaded_count);
      case "admin":
        return adminMenu(unreaded_count);
      case "webmaster":
        return webmasterMenu(unreaded_count);
      default:
        return null;
    }
  };

  const status_class_render = (status) => {
    switch (status) {
      case 1:
        return "good";
      case 2:
      case 4:
        return "wrong";
      case 3:
        return "verification";
      default:
        return {
          text: "-",
          class: null,
        };
    }
  };

  const unreaded_count = data?.reduce((a, b) => a + (!!!b?.status ? 1 : 0), 0);
  const menu_items = menu_type_render(user?.type, unreaded_count);

  const status_class =
    current_website?.subscription?.status !== "active"
      ? "disabled"
      : status_class_render(current_website?.status);

  return (
    <div className={`${mainClass}__menu`}>
      <div className={`${mainClass}__menu__logo`}>
        <NavLink to="/" onClick={() => setSidebarOpen(false)}>
          <Logo />
        </NavLink>
      </div>
      <div className={`${mainClass}__menu__wrapper`}>
        <div className={`${mainClass}__menu__list`}>
          {menu_items?.map(
            (
              {
                icon,
                label,
                href,
                extended,
                onclick,
                onMouseEnter,
                extended_items,
                count,
                ref,
                active,
              },
              index,
            ) =>
              !!href ? (
                <NavLink
                  key={index}
                  to={href}
                  end
                  onClick={() => setSidebarOpen(false)}
                  onMouseEnter={onMouseEnter}
                  className={({ isActive }) =>
                    isActive ? `${mainClass}__menu__list--active` : ""
                  }
                >
                  <div className={`${mainClass}__menu__list__icon`}>
                    {" "}
                    {!!count && (
                      <small
                        className={`${mainClass}__menu__list__icon__count`}
                      >
                        {count}
                      </small>
                    )}
                    {typeof icon === "string" ? (
                      <img src={icon} alt="" />
                    ) : (
                      icon
                    )}
                  </div>
                  <span>{label}</span>
                </NavLink>
              ) : (
                <div
                  key={index}
                  ref={ref}
                  onClick={onclick}
                  onMouseEnter={onMouseEnter}
                  className={classnames(`${mainClass}__menu__list__extend`, {
                    [`${mainClass}__menu__list__extend--open`]: !!extended,
                  })}
                >
                  <button
                    className={classnames(
                      `${mainClass}__menu__list__extend__button`,
                      {
                        [`${mainClass}__menu__list--active`]: !!active,
                      },
                    )}
                  >
                    <div className={`${mainClass}__menu__list__icon`}>
                      {icon}
                    </div>
                    <span>{label}</span>
                    {!!extended_items && <ArrowIcon />}
                  </button>
                  <FloatCard
                    ref={ref}
                    data={extended_items}
                    active={!!extended}
                    setSidebarOpen={setSidebarOpen}
                  />
                </div>
              ),
          )}
        </div>
      </div>
      {user?.type === "client" && current_website?._id && (
        <div className={`${mainClass}__menu__footer`}>
          <p>{t("Active website")}</p>
          <NavLink
            className={classnames(`${mainClass}__menu__footer__website`, {
              [`${mainClass}__menu__footer__website--${status_class}`]:
                !!status_class,
            })}
            to={`/websites/${current_website._id}`}
            onClick={() => setSidebarOpen(false)}
          >
            <i />
            <span>{current_website?.website ?? t("Website")}</span>
          </NavLink>
        </div>
      )}
    </div>
  );
};

export default Menu;
